import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../types/navigation';
import { BottomNavBar } from '../../../components/BottomNavBar';

export const DocumentsIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleNext = () => {
    navigation.navigate('DocumentsIntroScreen');
  };

  const handleBack = () => {
    navigation.navigate('Dashboard');
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={handleBack}
          >
            <Image
              source={require('../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollContent}>
          <View style={styles.content}>
            <Text style={styles.title}>Important Documents</Text>

            <Text style={styles.description}>
              Having  important documents in order for end-of-life planning is one of the greatest gifts you can give your loved ones. It ensures they have clear guidance on managing your affairs, from financial responsibilities and property matters to healthcare decisions and funeral arrangements. Organizing these documents minimizes confusion, prevents legal complications, and reduces stress during an already difficult time. By providing everything they need in one place, you empower your loved ones to honor your wishes and focus on healing, rather than scrambling to locate critical information.
            </Text>

            <TouchableOpacity
              style={styles.button}
              onPress={handleNext}
            >
              <Text style={styles.buttonText}>Get started {'>>'}</Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mainContent: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(50),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    padding: ms(20),
    alignItems: 'center',
    marginBottom: ms(100),
  },
  title: {
    fontSize: ms(28, 0.3),
    fontWeight: '600',
    color: '#2C4364',
    marginBottom: ms(30),
    textAlign: 'center',
    paddingHorizontal: ms(20),
  },
  description: {
    fontSize: ms(18, 0.3),
    color: '#666666',
    textAlign: 'center',
    marginBottom: ms(30),
    paddingHorizontal: ms(20),
    lineHeight: ms(25, 0.3),
  },
  button: {
    width: '100%',
    borderRadius: ms(30),
    padding: ms(15),
    alignItems: 'center',
    backgroundColor: '#29BFC0',
    marginTop: 'auto',
    marginBottom: ms(20),
  },
  buttonText: {
    fontSize: ms(18, 0.3),
    fontWeight: '500',
    color: '#FFFFFF',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: ms(20),
    paddingHorizontal: ms(20),
    paddingBottom: ms(140),
  },
});
